import { AssignmentService } from "@/services/AssignmentService";
import { useStore } from "@/store";
import {
  useToggleAdvizerSearchFilterOption,
  useTraitFilterOptions,
} from "@/store/selectors";
import {
  useActiveAssignmentId,
  useAssignments,
} from "@/store/selectors/assignmentSelectors";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export function PartnerDashboardLogic() {
  const [searchParams] = useSearchParams();
  const traitSearchParam = searchParams.get("trait");
  const { traits } = useTraitFilterOptions();
  const toggleFilterOption = useToggleAdvizerSearchFilterOption();
  const setAssignments = useStore((state) => state.partnerApp.setAssignments);
  const assignments = useAssignments();
  const activeAssignmentId = useActiveAssignmentId();
  const fullActiveAssignment = useStore(
    (state) => state.partnerApp.fullActiveAssignment,
  );
  const setFullActiveAssignment = useStore(
    (state) => state.partnerApp.setFullActiveAssignment,
  );
  const isAssignmentManagerOpen = useStore(
    (state) => state.partnerApp.isAssignmentManagerOpen,
  );
  const setActiveAssignmentId = useStore(
    (state) => state.partnerApp.setActiveAssignmentId,
  );

  useEffect(() => {
    AssignmentService.subscribeToUserAssignments((assignments: any[]) => {
      setAssignments(assignments);
    });
  }, [setAssignments]);

  useEffect(() => {
    if (activeAssignmentId) {
      AssignmentService.subscribeToFullAssignment(
        activeAssignmentId,
        (assignment) => {
          setFullActiveAssignment(assignment);
        },
      );
    } else {
      setFullActiveAssignment(null);
    }
  }, [activeAssignmentId, fullActiveAssignment?.id, setFullActiveAssignment]);

  useEffect(() => {
    if (isAssignmentManagerOpen && !activeAssignmentId) {
      // setActiveAssignmentId(Object.keys(assignments)[0]);
    }
  }, [
    isAssignmentManagerOpen,
    activeAssignmentId,
    assignments,
    setActiveAssignmentId,
  ]);

  useEffect(() => {
    if (traitSearchParam && traits.length > 0) {
      // setIsInlineAdvizerSearchOpen(true);
      const trait = traits.find((trait) => trait.slug === traitSearchParam);
      if (trait) {
        toggleFilterOption("traits", trait.id);
      }

      // setTimeout(() => {
      //   setIsInlineAdvizerSearchOpen(false);
      // }, 10);
      // setSearchParams({ trait: traitSearchParam });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [traitSearchParam, traits.length]);

  return null;
}
